<template>
  <div>
    <div class="title base">
      <div class="pl-2 flex">
        <div class="flex items-center" @click="checkAll">
          <div class="select" :class="{ 'checked': checkall }"></div>
          {{ $t("全选") }}
        </div>
        <span class="name">{{ $t("商品") }}</span>
      </div>
      <p class="price">{{ $t("单价") }}</p>
      <p class="weight">{{ $t("预估重量") }}</p>
      <p class="count">{{ $t("数量") }}</p>
      <p class="tip">{{ $t("小计") }}</p>
      <p iclassd="operation">{{ $t("操作") }}</p>
    </div>
    <div v-if="cart_info">
      <div v-for="item in cartLists" :key="item.supplier_info.sid">
        <!-- <div class="flex justify-start items-center cursor-pointer"
          @click="$goTo('/store/index?id=' + item.supplier_info.sid)">
          <span class="iconfont icon-q07 text-orange-400 pb-1 pr-1"></span>
          {{ item.supplier_info.name }}
          <span class="iconfont icon-right"></span>
        </div> -->
        <transition-group name="fade">
          <div class="base bd" v-for="val in item.products" :key="val.id">
            <div class="flex items-center py-4 pl-2">
              <span class="self-start mrl-0">
                <!-- <el-checkbox :disabled="val.disabled"  :checked="val.selected"></el-checkbox> -->
                <div class="select" :class="{ 'checked': val.selected }" @click="selectProduct(val)"></div>
                <!-- <input type="checkbox" :value="val" v-model="checkedProduct" @click="selectProduct(val)"/> -->
              </span>
              <CartItem class="inline-block !ml-2" :item="val.product"></CartItem>
            </div>
            <p>{{ $p(val.product.price) }}</p>
            <p>{{ val.product.weight * val.quantity }}kg</p>
            <p>
              <el-input-number v-model="val.quantity" :min="1" :max="val.product.stock" step-strictly
                @change="handleChange(val)" size="small"></el-input-number>
            </p>
            <p class="dollar text-red-500">
              {{ $p(val.quantity * val.product.price) }}
            </p>
            <p>
              <el-link type="danger" :underline="false" class="block" @click="del(val.product.id)">
                {{ $t("删除") }}
              </el-link>
              <el-link type="info" :underline="false" class="block">
                <p class="!text-main" @click="cancelFavorite(val)" v-if="val.is_like">
                  {{ $t("已收藏") }}
                </p>
                <p v-else @click="addFavorite(val)">
                  {{ $t("常购收藏") }}
                </p>
              </el-link>
            </p>
          </div>

        </transition-group>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive } from "@vue/runtime-dom";
import CartItem from "@/components/base/cartItem.vue";
import { computed, ref, watchEffect } from "@vue/composition-api";
import bus from "../../../API/util/bus";
export default defineComponent({
  components: { CartItem },
  setup(props, ctx) {
    const tip = computed(() => (info.price * count.value).toFixed(1));
    const info = reactive({
      price: 14.3,
      count: 1,
    });
    const count = ref(1);
    // 获取购物车信息
    const cart_info = computed(() => {
      return ctx.root.$store.state.cart.cart;
    });
    const cartLists = computed(() => {
      let arrs = []
      cart_info.value.map((item) => {
        if (item.product.status != 10 || !item.product.stock) {
          item.disabled = true
        }
        ctx.root.$set(item, 'selected', false)
        let r = arrs.find(arr => arr?.supplier_info?.sid == item.product
          ?.supplier_info?.sid)
        if (r) {
          r.products.push(item)
        } else {
          let obj = {
            supplier_info: item.product.supplier_info,
            products: [item]
          }
          arrs.push(obj)
        }
      })

      return arrs
    })
    const handleChange = async (v) => {
      await ctx.root.$callapi("trade/editWithCart", {
        pid: v.product.id,
        quantity: v.quantity,
      });
    };
    // 删除单个商品信息
    const del = async (pid) => {
      try {
        const res = await ctx.root.$callapi("trade/editWithCart", {
          pid,
          quantity: -1,
        });
        if (res.code === 0) {
          ctx.root.$toast(ctx.root.$t('删除成功'), 'success')
          ctx.root.$store.commit("REMOVE_CART", pid);
          bus.emit("checked", checkall.value);
          bus.emit("dealOrder", selectedProduct.value);
        }
      } catch (e) {
        return e;
      }
    };

    //获取购物车信息
    const cart_message = async () => {
      const res = await ctx.root.$callapi("trade/getMyCartList");
      if (res.code === 0) {
        ctx.root.$store.commit("SAVE_CART", res.data);
      }
    };
    //取消收藏
    const cancelFavorite = async (val) => {
      await ctx.root.$callapi("user/doCollect", {
        objid: val.product.id,
        model: "product",
        action: "cancel",
      });
      val.is_like = false
    };
    //添加收藏
    const addFavorite = async (val) => {
      await ctx.root.$callapi("user/doCollect", {
        objid: val.product.id,
        model: "product",
      });
      // cart_message();
      // console.log(val);
      val.is_like = true
    };
    //获取收藏信息,修改按键
    const checkedProduct = ref([]);
    const checkAll = () => {
      let val = checkall.value ? false : true
      cart_info.value.map(item => {
        if (!item.disabled) {
          item.selected = val
        }
      })
      bus.emit("checked", checkall.value);
      bus.emit("dealOrder", selectedProduct.value);
    };
    const noDisableProduct = computed(() => {
      let arr = cart_info.value.filter(i => !i.disabled)
      return arr
    })
    const checkall = computed(() => {
      console.log(selectedProduct.value)
      return  selectedProduct.value.length && selectedProduct.value.length == noDisableProduct.value.length
    })
    bus.on("checkAll", () => {
      checkAll();
    });

    bus.on("batchCollect", (e) => {
      cart_info.value.map(item => {
        if (e.includes(item.product.id)) {
          item.is_like = true
        }
      })
    });
    bus.on("batchDelCart", (e) => {
      // console.log(e);
      // e?.map(item => {
      //   ctx.root.$store.commit("REMOVE_CART", item);
      // })
      bus.emit("dealOrder", selectedProduct.value);
    });
    const selectedProduct = computed(() => {
      let arr = cartLists.value.map(item => item.products).flat(1)?.filter(i => i.selected == true)
      return arr
    })
    const selectProduct = (val) => {
      if(val.disabled)return
      val.selected = !val.selected
      bus.emit("checked", checkall.value);
      bus.emit("dealOrder", selectedProduct.value);
    }


    return {
      handleChange,
      info,
      tip,
      count,
      cart_info,
      del,

      checkAll,
      checkedProduct,
      checkall,
      cancelFavorite,
      addFavorite,
      cartLists,
      selectedProduct,
      selectProduct

    };
  },
});
</script>

<style scoped lang="scss">
.base {
  @apply;
  display: grid;
  grid-template-columns: 3fr repeat(2, 1fr) 2fr repeat(2, 1fr);

  >div {
    @apply space-x-32;
    justify-self: start;
  }
}

.title {
  @apply border mb-4 py-3;
  background-color: #f4f4f5;
}

.bd {
  @apply mb-2 border;

  >p {
    @apply border-l flex-center flex-col;
  }

  >div {
    @apply w-full text-left;
  }
}

.select {
  width: 1rem;
  height: 1rem;
  background-color: #fff;
  -webkit-appearance: none;
  border: 1px solid #c9c9c9;
  border-radius: 3px;
  outline: none;

  &.checked {
    @apply bg-green-600;
    background-size: 100% 100%;

    &::after {
      // content: "✓";
      content: "✓";
      color: #fff;
      font-size: 1rem;
      line-height: 1rem;
      font-weight: bold;
      text-align: center;
      display: block;
    }
  }
}

input[type="checkbox"] {
  width: 1rem;
  height: 1rem;
  background-color: #fff;
  -webkit-appearance: none;
  border: 1px solid #c9c9c9;
  border-radius: 3px;
  outline: none;
}

input[type="checkbox"]:checked {
  @apply bg-green-600;
  background-size: 100% 100%;

  &::after {
    // content: "✓";
    content: "✓";
    color: #fff;
    font-size: 1rem;
    line-height: 1rem;
    font-weight: bold;
    text-align: center;
    display: block;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}
</style>
